/* eslint-disable no-bitwise */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import Cookies from "js-cookie";
var organizationId = "A92B3BC75245B1030A490D4D@AdobeOrg";
var domain = ".lululemon.com";
var hash = function(str) {
    var hashValue = 0;
    for(var i = 0, chr; i < str.length; i += 1){
        chr = str.charCodeAt(i);
        hashValue = (hashValue << 5) - hashValue + chr;
        hashValue |= 0; // Convert to 32bit integer
    }
    return hashValue;
};
var decodeAMCV = function(cookieValue) {
    var parts = decodeURIComponent(cookieValue || "").split("|");
    var values = {};
    if (parts[0].match(/^[-0-9]+$/)) parts.shift();
    if (parts.length % 2 === 1) parts.pop();
    for(var i = 0; i < parts.length; i += 2){
        var _parts_i_split = _sliced_to_array(parts[i].split("-"), 2), name = _parts_i_split[0], expires = _parts_i_split[1];
        var value = parts[i + 1];
        if (name === "MCCIDH") {
            value = null;
        }
        values[name] = {
            value: value
        };
        if (expires) {
            values[name].expires = expires;
        }
    }
    return values;
};
var encodeAMCV = function(values) {
    var _window_s, _window;
    var cookie = Object.keys(values).map(function(name) {
        var _values_name = values[name], value = _values_name.value, expires = _values_name.expires;
        var expirtySuffix = "-" + expires;
        return "" + name + (expires ? expirtySuffix : "") + "|" + value;
    }).join("|");
    var _ref = ((_window = window) == null ? void 0 : (_window_s = _window.s) == null ? void 0 : _window_s.visitor) || {}, _ref_version = _ref.version, version = _ref_version === void 0 ? "5.0.0" : _ref_version, _ref_audienceManagerServer = _ref.audienceManagerServer, audienceManagerServer = _ref_audienceManagerServer === void 0 ? "dpm.demdex.net" : _ref_audienceManagerServer, _ref_audienceManagerServerSecure = _ref.audienceManagerServerSecure, audienceManagerServerSecure = _ref_audienceManagerServerSecure === void 0 ? "" : _ref_audienceManagerServerSecure;
    var settingsDigest = version;
    if (audienceManagerServer) settingsDigest += "|" + audienceManagerServer;
    if (audienceManagerServerSecure) settingsDigest += "|" + audienceManagerServerSecure;
    var expires = new Date();
    expires.setUTCFullYear(expires.getUTCFullYear() + 2);
    Cookies.set("AMCV_" + organizationId, encodeURIComponent(hash(settingsDigest) + "|" + cookie), {
        expires: expires /* 2 years */ ,
        domain: domain
    });
};
var decodeMbox = function(cookieValue) {
    var mbox = (cookieValue || "").split("|");
    var values = {};
    mbox.forEach(function(mboxElement) {
        var _mboxElement_split = _sliced_to_array(mboxElement.split("#"), 3), name = _mboxElement_split[0], value = _mboxElement_split[1], expires = _mboxElement_split[2];
        values[name] = {
            value: value,
            expires: expires
        };
    });
    return values;
};
var encodeMbox = function(values) {
    var cookie = Object.keys(values).map(function(name) {
        var _values_name = values[name], value = _values_name.value, expires = _values_name.expires;
        return [
            name,
            value,
            expires
        ].join("#");
    }).join("|");
    var expires = new Date(Date.now() + 2 * 864e5);
    expires.setUTCFullYear(expires.getUTCFullYear() + 2);
    Cookies.set("mbox", cookie, {
        expires: expires /* 2 years and 2 days */ ,
        domain: domain
    });
};
var AdobeCookies = function() {
    var amcvCookie;
    var mboxCookie;
    var amcvValues = {};
    var mboxValues = {};
    var amcvGetterSetter = function(name) {
        return {
            get: function() {
                var _amcvValues_name, _amcvValues;
                // eslint-disable-next-line no-underscore-dangle
                var _amcv = Cookies.get("AMCV_" + organizationId);
                if (_amcv !== amcvCookie) {
                    Object.assign(amcvValues, decodeAMCV(_amcv));
                    amcvCookie = _amcv;
                }
                return (_amcvValues = amcvValues) == null ? void 0 : (_amcvValues_name = _amcvValues[name]) == null ? void 0 : _amcvValues_name.value;
            },
            set: function(value) {
                var _amcvValues;
                Object.assign(amcvValues, _define_property({}, name, _extends({}, ((_amcvValues = amcvValues) == null ? void 0 : _amcvValues[name]) || {}, {
                    value: value
                })));
                encodeAMCV(amcvValues);
            }
        };
    };
    var mboxGetterSetter = function(name) {
        return {
            get: function() {
                var _mboxValues_name, _mboxValues;
                // eslint-disable-next-line no-underscore-dangle
                var _mbox = Cookies.get("mbox");
                if (_mbox !== mboxCookie) {
                    Object.assign(mboxValues, decodeMbox(_mbox));
                    mboxCookie = _mbox;
                }
                return (_mboxValues = mboxValues) == null ? void 0 : (_mboxValues_name = _mboxValues[name]) == null ? void 0 : _mboxValues_name.value;
            },
            set: function(value) {
                var _mboxValues;
                Object.assign(mboxValues, _define_property({}, name, _extends({}, ((_mboxValues = mboxValues) == null ? void 0 : _mboxValues[name]) || {}, {
                    value: value
                })));
                encodeMbox(mboxValues);
            }
        };
    };
    return Object.defineProperties({}, {
        MCAAMB: amcvGetterSetter("MCAAMB"),
        MCMID: function() {
            var getset = amcvGetterSetter("MCMID");
            return {
                get: function() {
                    var value = getset.get();
                    if (!value) {
                        // check s_ecid cookie
                        var parts = decodeURIComponent(Cookies.get("s_ecid") || "").split("|");
                        for(var i = 0; i < parts.length; i += 2){
                            if (parts[i] === "MCMID") {
                                // Apply mcmid back to AMCV cookie
                                getset.set(parts[i + 1]);
                                return parts[i + 1];
                            }
                        }
                    }
                    return value;
                },
                set: function(value) {
                    getset.set(value);
                    var expires = new Date();
                    expires.setUTCFullYear(expires.getUTCFullYear() + 2);
                    // Mirror MCMID to s_ecid cookie
                    Cookies.set("s_ecid", encodeURIComponent("MCMID|" + value), {
                        expires: expires,
                        domain: domain
                    });
                }
            };
        }(),
        MCAAMLH: amcvGetterSetter("MCAAMLH"),
        MCAID: amcvGetterSetter("MCAID"),
        MCOPTOUT: amcvGetterSetter("MCOPTOUT"),
        PC: mboxGetterSetter("PC"),
        session: mboxGetterSetter("session"),
        mboxEdgeCluster: {
            get: function() {
                return Cookies.get("mboxEdgeCluster");
            },
            set: function(value) {
                Cookies.set("mboxEdgeCluster", value, {
                    expires: new Date(Date.now() + 30 * 36e5),
                    domain: domain
                });
            }
        },
        at_qa_mode: {
            get: function() {
                var value = Cookies.get("at_qa_mode");
                if (value) {
                    return JSON.parse(decodeURIComponent(value));
                }
                return undefined;
            },
            set: function(value) {
                Cookies.set("at_qa_mode", encodeURIComponent(JSON.stringify(value)), {
                    expires: new Date(Date.now() + 30 * 36e5),
                    domain: domain
                });
            }
        }
    });
}();
export default AdobeCookies;

//# sourceMappingURL=adobeCookies.js.map